import cancel from "../assets/images/navbar/cancel.png";
import group from "../assets/images/group/group.png";
import edit from "../assets/images/group/edit2.png";
import clock from "../assets/images/group/clock.png";
import creditcard from "../assets/images/support/credit-card.png";
import location from "../assets/images/location.png";
import rightarrow from "../assets/images/arrow-right.png";
import { useNavigate } from "react-router-dom";

interface GroupModalProps {
  onClose: () => void;
}

const GroupModal = ({ onClose }: GroupModalProps) => {
  const navigate = useNavigate();

  return (
    <div>
      {/* Backdrop Overlay */}
      <div
        className="fixed inset-0 bg-black bg-opacity-50 z-[1003]"
        onClick={onClose}
      />

      {/* Modal Container */}
      <div className="fixed inset-0 flex items-center justify-center z-[1004] pointer-events-none">
        <div
          className="w-[545px] p-8 rounded-[24px] bg-white pointer-events-auto relative"
          style={{
            boxShadow: "-23px 23px 72px 0 rgba(0, 0, 0, 0.15)",
          }}
          onClick={(e) => e.stopPropagation()}
        >
          {/* Close Button */}
          <div
            className="absolute top-6 right-6 h-[36px] w-[36px] cursor-pointer border rounded-full p-[7px] bg-white flex items-center justify-center"
            onClick={onClose}
          >
            <img src={cancel} alt="Close" className="h-[18px] w-[18px]" />
          </div>

          {/* heading */}
          <div className="pb-[24px] border-b-2">
            <p className="text-[#050505] font-Urbanist text-[20px] font-semibold leading-[140%]">
              Group Order
            </p>
          </div>

          {/* main section */}
          <div className="flex flex-col justify-center items-center mt-[24px]">
            <div>
              <img src={group} alt="Group" className="w-[370px] h-[212px]" />
            </div>
            <div className="flex gap-4 items-center mt-[24px]">
              <h6 className="text-[#050505] font-Urbanist text-[22px] font-semibold leading-[140%] ">
                Aman Bansal’s Group
              </h6>
              <img src={edit} alt="Edit" className="w-[20px] h-[20px]" />
            </div>
            <p className="text-[#050505] font-Urbanist text-[16px] font-medium leading-[140%] ">
              Invite your friends to add items in single cart
            </p>
          </div>

          <div className="border rounded-[16px] p-[12px]">
            <div className="flex gap-[12px] items-center pb-[12px]  border-b-2">
              <div className="flex justify-center items-center h-[48px] w-[48px] rounded-[16px] border-2">
                <img src={clock} alt="clock" className="h-[24px] w-[24px]" />
              </div>
              <div>
                <h6 className="text-[#6A6A6A] text-center font-Urbanist text-[14px] font-medium leading-[140%]">
                  When to Deliver
                </h6>
                <p className="text-[#050505] font-Urbanist text-[16px] font-normal leading-[160%]">
                  Deliver Now
                </p>{" "}
              </div>
            </div>
            <div className="flex gap-[12px] items-center py-[12px]  border-b-2">
              <div className="flex justify-center items-center h-[48px] w-[48px] rounded-[16px] border-2">
                <img
                  src={location}
                  alt="location"
                  className="h-[24px] w-[24px]"
                />
              </div>
              <div>
                <h6 className="text-[#6A6A6A] text-center font-Urbanist text-[14px] font-medium leading-[140%]">
                  Where to Deliver
                </h6>
                <p className="text-[#050505] font-Urbanist text-[16px] font-normal leading-[160%]">
                  Sector 62, Noida, Uttar Pradesh
                </p>{" "}
              </div>
            </div>
            <div className="flex gap-[12px] items-center mt-[12px]">
              <div className="flex justify-center items-center h-[48px] w-[48px] rounded-[16px] border-2">
                <img
                  src={creditcard}
                  alt="credit card"
                  className="h-[24px] w-[24px]"
                />
              </div>
              <div>
                <h6 className="text-[#6A6A6A] text-center font-Urbanist text-[14px] font-medium leading-[140%]">
                  Who is Paying
                </h6>
                <p className="text-[#050505] font-Urbanist text-[16px] font-normal leading-[160%]">
                  You are paying for this order
                </p>{" "}
              </div>
            </div>
          </div>

          <div className="h-[1px] w-full bg-[#E9E9E9] my-[24px]"></div>

          <button
            className="w-full flex items-center justify-between py-4 px-6 bg-[#FF8A00] rounded-[150px] cursor-pointer hover:bg-[#5f0289] transition-colors"
            onClick={() => {
              onClose();
              navigate("/group-order");
            }}
          >
            <span className="w-full text-white text-center font-Urbanist text-[20px] font-semibold leading-[140%]">
              Create Your Group
              <img
                src={rightarrow}
                alt="Right Arrow"
                className="inline-block ml-2 h-[24px] w-[24px]"
              />
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default GroupModal;
